var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCuentaFull(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Ico / Bottom Nav / large / cuenta-full") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ico-/-Bottom-Nav-/-large-/-cuenta-full",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,21.0308 C9.692,21.0308 7.591,20.1538 5.993,18.7238 C7.793,17.6018 9.857,17.0038 12,17.0038 C14.148,17.0038 16.209,17.5978 18.01,18.7218 C16.411,20.1528 14.309,21.0308 12,21.0308 M12,6.0028 C14.204,6.0028 15.997,7.7958 15.997,9.9998 C15.997,12.2038 14.204,13.9968 12,13.9968 C9.796,13.9968 8.003,12.2038 8.003,9.9998 C8.003,7.7958 9.796,6.0028 12,6.0028 M12,1.9998 C6.477,1.9998 2,6.4768 2,11.9998 C2,17.5228 6.477,21.9998 12,21.9998 C17.522,21.9998 22,17.5228 22,11.9998 C22,6.4768 17.522,1.9998 12,1.9998",
    id: "Fill-1",
    fill: "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCuentaFull);
export default __webpack_public_path__ + "static/media/cuenta-full.ae188f5a2728488e7d520d0606614d58.svg";
export { ForwardRef as ReactComponent };